import styled from 'styled-components';
// import { mediaMax } from '../Media Template/Media Template';

export const StyledText = styled.span.attrs({
  width: props => props.width,
  height: props => props.height,
  fontFamily: props => props.fontfamily,
  fontSize: props => props.fontsize,
  fontWeight: props => props.fontweight,
  fontStyle: props => props.fontstyle,
  fontStretch: props => props.fontstretch,
  lineheight: props => props.lineheight,
  letterSpacing: props => props.letterspacing,
  color: props => props.color,
  padding: props => props.padding
})`
  width: ${props => props.width};
  height: ${props => props.height};
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
  font-style: ${props => props.fontStyle};
  font-stretch: ${props => props.fontStretch};
  line-height: ${props => props.lineheight};
  letter-spacing: ${props => props.letterSpacing};
  color: ${props => props.color};
  padding: ${props => props.padding};
`;

/* ${mediaMax.phone`padding: 0`};  */
/* Changed because Logo is not adjusting with padding: 0 */
